document.addEventListener('DOMContentLoaded', () => {
  const shortDescription = document.querySelector('#product-description-short');
  const fullDescription = document.querySelector('#product-description-full');
  const btn = document.querySelector('#toggle-description-btn');
  const icon = document.querySelector('.product-hero-description__btn__icon');
  const buttonText = btn.querySelector('.button-text');

  const updateDescription = (isExpanded) => {
    shortDescription.classList.toggle('hidden', isExpanded);
    fullDescription.classList.toggle('hidden', !isExpanded);
    icon.classList.toggle('down', !isExpanded);
    icon.classList.toggle('up', isExpanded);
    if (buttonText) {
      buttonText.textContent = isExpanded ? 'Pokaż mniej' : 'Rozwiń tekst';
    }
    btn.setAttribute('aria-expanded', String(isExpanded));
  };

  const toggleDescription = () => {
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    updateDescription(!isExpanded);
  };

  if (btn) {
    btn.addEventListener('click', toggleDescription);
  }

  updateDescription(btn.getAttribute('aria-expanded') === 'true');
});
